import classNames from 'classnames';
import {
  Icon,
  ContentBlock,
  FlexContainer,
  TitledBlock,
  Txt,
} from 'components';
import { TDSlink } from 'config';
import { depositStatusMap } from 'config/types';
import { useTenancy } from 'state';
import styles from './ViewPaymentsDepositDetails.module.scss';

/**
 * ViewPaymentsDepositDetails
 *
 * @return {JSX.Element}
 */
const ViewPaymentsDepositDetails = ({ className }) => {
  const tenancyDoc = useTenancy();
  const { data: tenancy } = tenancyDoc;

  // TODO: possibly need to check is all the todo items completed
  const showGoToBeginTenancy = true; // tenancy.hasBegunTenancy

  return (
    <FlexContainer
      className={classNames(
        styles.ViewPaymentsDepositDetails,
        className,
        ViewPaymentsDepositDetails.displayName
      )}
      column
      gap
    >
      {!showGoToBeginTenancy ? null : (
        <ContentBlock gapHalf alignCenter>
          <FlexContainer column gapHalf flex>
            <Txt caption>TO DO</Txt>
            <Txt xx>Begin the tenancy</Txt>
            <Txt regular>
              This tenancy must have begun before it can accept deposit
              payments. Go to the previous screen and tap 'Begin tenancy'.
            </Txt>
          </FlexContainer>
          {/*<Icon name="calendar" />*/}
        </ContentBlock>
      )}
      <TitledBlock title="Deposit account number">
        <ContentBlock column={false} row gap alignCenter>
          <FlexContainer column gapHalf flex>
            <Txt caption>
              STATUS - {depositStatusMap[tenancy.deposit?.status] || 'Unknown'}
            </Txt>
            <Txt xx>{tenancy.payments?.depositReference}</Txt>
          </FlexContainer>
          <FlexContainer>
            <Txt caption>
              <Icon name="secure" />
            </Txt>
          </FlexContainer>
        </ContentBlock>
      </TitledBlock>
      <TitledBlock title="Where its held">
        <ContentBlock noPadding column overflowHidden>
          <FlexContainer className={styles.SchemaHeader}></FlexContainer>
          <FlexContainer className={styles.SchemaBody} column gap>
            <Txt xx>Tenancy Deposit Scheme</Txt>
            <Txt regular>
              Once registered and paid you will receive a deposit account number
              and certificate. This is used to log into TDS's portal and raise
              any disputes and repayment requests there. Their registered
              address is:
            </Txt>
            <FlexContainer column>
              <Txt regular>The Maylands Building</Txt>
              <Txt regular>200 Maylands Avenue</Txt>
              <Txt regular>Hemel</Txt>
              <Txt regular>Hempstead</Txt>
              <Txt regular>HP2 7TG</Txt>
            </FlexContainer>
            <Txt regular>
              For more details go to{' '}
              <a href={TDSlink} target="_blank" rel="noreferrer">
                {TDSlink}
              </a>
            </Txt>
          </FlexContainer>
        </ContentBlock>
      </TitledBlock>
    </FlexContainer>
  );
};

ViewPaymentsDepositDetails.displayName = 'ViewPaymentsDepositDetails';

export default ViewPaymentsDepositDetails;
